"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SOCIAL_MAP = void 0;

var _react = _interopRequireWildcard(require("react"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _reduce = _interopRequireDefault(require("lodash/reduce"));

var _gettext = _interopRequireDefault(require("js-utils/gettext"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _device_fingerprint = require("device_fingerprint");

var _FacebookLoginButton = _interopRequireDefault(require("./FacebookLoginButton"));

var _AppleLoginButton = _interopRequireDefault(require("./AppleLoginButton"));

var _constants = require("./constants");

var _SOCIAL_MAP, _PropTypes$shape;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SOCIAL_MAP = (_SOCIAL_MAP = {}, _defineProperty(_SOCIAL_MAP, _constants.SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE, _AppleLoginButton.default), _defineProperty(_SOCIAL_MAP, _constants.SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK, _FacebookLoginButton.default), _SOCIAL_MAP);
exports.SOCIAL_MAP = SOCIAL_MAP;

var SocialLogin =
/*#__PURE__*/
function (_Component) {
  _inherits(SocialLogin, _Component);

  function SocialLogin(props) {
    var _this;

    _classCallCheck(this, SocialLogin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SocialLogin).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "_handleSocialProviderClick", function (socialProvider, state) {
      var _this$props = _this.props,
          fp = _this$props.fp,
          onSocialProviderClick = _this$props.onSocialProviderClick;

      if (fp) {
        (0, _device_fingerprint.create)({
          data: {
            fpid: ''
          }
        });
      }

      onSocialProviderClick(socialProvider, state);
    });

    _defineProperty(_assertThisInitialized(_this), "_handlePrivacyPolicyClick", function (e) {
      var targetName = e.target.name;

      if (targetName) {
        var privacyPolicyHandler = _this.privacyPolicyNameToHandler[targetName];

        if (privacyPolicyHandler) {
          privacyPolicyHandler();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_renderButtons", function () {
      var _this$props2 = _this.props,
          onSocialConnectVerified = _this$props2.onSocialConnectVerified,
          onSocialConnectNotAuthorized = _this$props2.onSocialConnectNotAuthorized,
          handleOnLoadComplete = _this$props2.handleOnLoadComplete,
          _this$props2$socialSS = _this$props2.socialSSOSettings,
          socialSSOSettings = _this$props2$socialSS === void 0 ? {} : _this$props2$socialSS;
      var buttons = (0, _reduce.default)(SOCIAL_MAP, function (memo, SocialLoginButton, socialProvider) {
        var settings = socialSSOSettings[socialProvider];

        if (settings) {
          var component = _react.default.createElement("div", {
            key: socialProvider,
            className: "eds-l-mar-bot-2"
          }, _react.default.createElement(SocialLoginButton, _extends({
            onSocialConnectVerified: onSocialConnectVerified.bind(null, socialProvider),
            onSocialConnectNotAuthorized: onSocialConnectNotAuthorized.bind(null, socialProvider),
            handleOnLoadComplete: handleOnLoadComplete,
            onClick: _this._handleSocialProviderClick.bind(null, socialProvider)
          }, settings)));

          return [].concat(_toConsumableArray(memo), [component]);
        }

        return memo;
      }, []);
      return buttons;
    });

    var _this$props3 = _this.props,
        onTermsOfServiceClick = _this$props3.onTermsOfServiceClick,
        onComunityGuidelinesClick = _this$props3.onComunityGuidelinesClick,
        onPrivacyPolicyClick = _this$props3.onPrivacyPolicyClick;
    _this.privacyPolicyNameToHandler = {
      tos: onTermsOfServiceClick,
      'community-guidelines': onComunityGuidelinesClick,
      'privacy-policy': onPrivacyPolicyClick
    };
    return _this;
  }

  _createClass(SocialLogin, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          socialSSOSettings = _this$props4.socialSSOSettings;

      var socialButtons = this._renderButtons();

      var divider = null;
      var privacyPolicy = null;
      var twoStepsSignup = socialSSOSettings && socialSSOSettings.twoStepsSignup;

      if (!(0, _isEmpty.default)(socialSSOSettings)) {
        divider = _react.default.createElement("div", {
          className: "eds-l-mar-vert-4 eds-text--center"
        }, _react.default.createElement("span", {
          className: "eds-text-bs"
        }, (0, _gettext.default)('or')));

        if (!twoStepsSignup) {
          privacyPolicy = _react.default.createElement("div", {
            className: "eds-l-mar-top-3"
          }, _react.default.createElement("div", {
            className: "eds-text--center"
          }, _react.default.createElement("span", {
            className: "eds-text-color--grey-600 eds-text-bs eds-l-mar-bot-5",
            onClick: this._handlePrivacyPolicyClick,
            onKeyDown: this._handlePrivacyPolicyClick,
            role: "presentation" // Needed for links to work in gettext; no user-generated content
            // eslint-disable-next-line react/no-danger
            ,
            dangerouslySetInnerHTML: {
              __html: (0, _gettext.default)('By continuing, I accept the Eventbrite <a href="/tos" class="eds-link" target="_blank" name="tos" rel="noopener noreferrer">terms of service</a>, <a href="/community-guidelines" class="eds-link" name="community-guidelines" target="_blank" rel="noopener noreferrer">community guidelines</a> and have read the <a href="/privacypolicy" class="eds-link" name="privacy-policy" target="_blank" rel="noopener noreferrer">privacy policy</a>.')
            }
          })));
        }
      }

      return _react.default.createElement("div", null, children, divider, socialButtons, privacyPolicy);
    }
  }]);

  return SocialLogin;
}(_react.Component);

exports.default = SocialLogin;

_defineProperty(SocialLogin, "propTypes", {
  children: _propTypes.default.node.isRequired,
  socialSSOSettings: _propTypes.default.shape((_PropTypes$shape = {}, _defineProperty(_PropTypes$shape, _constants.SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK, _propTypes.default.shape({
    appId: _propTypes.default.string,
    version: _propTypes.default.string,
    scope: _propTypes.default.string,
    reRequestPermissions: _propTypes.default.bool
  })), _defineProperty(_PropTypes$shape, _constants.SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE, _propTypes.default.shape({
    clientId: _propTypes.default.string,
    redirectURI: _propTypes.default.string,
    scope: _propTypes.default.string,
    state: _propTypes.default.string
  })), _PropTypes$shape)),
  onSocialConnectVerified: _propTypes.default.func,
  onSocialConnectNotAuthorized: _propTypes.default.func,
  handleOnLoadComplete: _propTypes.default.func,
  onSocialProviderClick: _propTypes.default.func,
  onTermsOfServiceClick: _propTypes.default.func,
  onComunityGuidelinesClick: _propTypes.default.func,
  onPrivacyPolicyClick: _propTypes.default.func
});

_defineProperty(SocialLogin, "defaultProps", {
  onSocialProviderClick: _noop.default,
  onSocialConnectVerified: _noop.default,
  onSocialConnectNotAuthorized: _noop.default
});
//# sourceMappingURL=SocialLogin.js.map